import React from 'react';
import { withRouter } from 'react-router';
import { Form, Modal, Row, Col } from 'antd';
import api from '../../../helpers/api';
import Spinner from '../../elements/Spinner';

class IPSI extends React.Component {
    constructor(props) {
        super(props);
        window.addEventListener('message', this.ipsiResultFunction);
    };

    componentWillUnmount = () => {
        window.removeEventListener('message', this.ipsiResultFunction);
    };

    state = {
        iframeSrc: null
    };

    /**
     * On load or change of props, we pull the iframe from the DOM and replace it's source.
     * The reason for doing so is that if we change the src while in the DOM, it adds an entry to the browser history
     * Which means that our 'goBack()' functionality does not work as expected.
     */
    async componentDidMount() {
        try {
            let IframeUrl = await this.getIframeUrl();
            this.setState({ iframeSrc: IframeUrl });
        } catch (error) {}
    };

    componentDidUpdate(prevProps, prevState) {
        // Only re-render the form if we change the values
        if (prevProps.product_id !== this.props.product_id || prevProps.product_quantity !== this.props.product_quantity) {
            this.setState({ iframeSrc: null }, async () => {
                let IframeUrl = await this.getIframeUrl();
                this.setState({ iframeSrc: IframeUrl });
            });
        }
    };

    ipsiResultFunction = (message) => {
        try {
            let data = JSON.parse(message.data);
            if(data.info === "Payment outcome for the transaction.") {
                // If the responseCode indicates success - See one of these links for more details:
                // https://ipsi.atlassian.net/servicedesk/customer/portal/2/article/1597177857 (iframes the wiki link below)
                // https://ipsi.atlassian.net/wiki/spaces/PCKB/pages/1597177857/Payment+Response+Codes
                if (
                    ['00', '08', '16', '77'].includes(data.responseCode)
                ) {
                    this.processCart(data);
                } else {
                    Modal.error({
                        className: 'ipsi-error',
                        title: 'Unable to process Credit Card.',
                        content: 'Please check card details and try again.',
                        icon: false,
                        closable: false,
                        keyboard: false,
                        okButtonProps: {
                            type: "primary"
                        },
                        onOk: () => {
                            this.forceUpdate();
                        }
                    });
                }
            }
        } catch(e) {
            //ignore
        }
    };

    processCart = (payment_data) => {
        this.props.changeSubmitting();

        let data = {
            chosen_driver: this.props.chosen_driver,
            student_id: this.props.student_id,
            product_id: this.props.product_id,
            product_quantity: this.props.product_quantity,
            payment_amount: (this.props.products[this.props.product_id].product_prices[0].base_cost * this.props.product_quantity).toFixed(2),
            payer_name: payment_data.name,
            external_reference_id: payment_data.txnReference,
            received_date: payment_data.transactionDate,
            source: 'Diary'
        };

        api.post("purchases/processIPSIPayment", {
            body: JSON.stringify(data)
        })
        .then(data => {
            this.props.changeSubmitting();
            if (typeof data.result === 'object' && data.result.success) {
                this.props.changeSubmitting();
                Modal.success({
                    title: "Payment Successful",
                    content: (
                        <div>
                            <p>The Payment was successfully processed.</p>
                        </div>
                    ),
                    closable: false,
                    keyboard: false,
                    onOk: () => {
                        if(this.props.inModal) {
                            this.props.successfulPayment();
                        } else {
                            this.props.backToReferrer();
                        }
                    }
                });
            } else {
                Modal.error({
                    title: 'Unable to process Credit Card.',
                    content: (
                        <div>
                            <p>Please check card details and try again.</p>
                        </div>
                    ),
                    closable: false,
                    keyboard: false
                });
            }
        });
    }

    // Unique Reference to identify this purchase
    reference = () => {
        // Student ID + UNIX Timestamp
        return this.props.student_id + "_" + Date.now();
    };

    getIframeUrl = async() => {
        // check if the reCAPTCHA script has loaded
        if (!window.grecaptcha || !window.grecaptcha.enterprise) {
            console.error("reCAPTCHA script not loaded.");
            // show an error modal to the user here?
            return;
        }

        // Wrap the callback in a Promise so we can await the result
        return new Promise((resolve, reject) => {
            window.grecaptcha.enterprise.ready(async () => {
                try {
                    const token = await window.grecaptcha.enterprise.execute('6LcsZPwrAAAAAAZwk8L4hNkv3Jk6fS1CnWp25dFK', {action: 'GET_PAYMENT_URL'});

                    let postParams = {
                        amount: (this.props.products[this.props.product_id].product_prices[0].base_cost * this.props.product_quantity).toFixed(2),
                        merchReference: this.reference(),
                        token: token,
                        staff: true,
                        email: this.props.studentData.user.email
                    };

                    const res = await api.post("payments/url", {
                        body: JSON.stringify(postParams)
                    });

                    if (res.status !== "OK" || typeof res.result.url === "undefined") {
                        console.error("API error, failed to get payment URL:", res);
                        reject(new Error("Failed to get payment URL.")); // Reject the promise on failure
                    } else {
                        resolve(res.result.url); // Resolve the promise with the URL
                    }

                } catch (error) {
                    // Handle any errors during execute() or api.post()
                    console.error("reCAPTCHA execution or API call failed:", error);
                    reject(error);
                }
            });
        });
    };

    render(){
        return (
            <div id="ipsi-trent">
                <Row>
                    <Col 
                        xs={{ span: 18, offset: 3 }}
                        lg={{ span: 12, offset: 6 }}
                    >
                        <div>
                            {this.state.iframeSrc === null ? (
                                <Spinner id='reminderDrawerSpinner' />
                            ) : (
                                <iframe
                                    title="IPSI Form Iframe"
                                    id="ipsi-form"
                                    src={this.state.iframeSrc}
                                ></iframe>
                            )}
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
};

const IPSIForm = Form.create({name: 'ipsi_form'})(IPSI);

export default withRouter(IPSIForm);
